<template>
  <div class="row">
    <div class="col-12">
      <form @submit.prevent="onSubmit()" ref="noncompliance_model_form">
        <div class="form-group row">
          <div class="col-lg-3">
            <label>ID</label>
            <input
              type="text"
              v-model="noncompliance_model.noncompliance_model_id"
              class="form-control"
              placeholder="ID"
            />
          </div>
          <div class="col-lg-9">
            <label>Natureza do risco</label>
            <Dropdown
              v-model="
                noncompliance_model.noncompliance_model_nature_of_risk_name
              "
              :editable="true"
              :options="noncompliance_model_natures_of_risk"
              class="w-100"
              option-label="name"
              option-value="name"
            />
          </div>
        </div>
        <div class="form-group">
          <label>Descrição</label>
          <textarea
            v-model="noncompliance_model.noncompliance_model_description"
            class="form-control"
            placeholder="Descrição"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Itens da norma</label>
          <MultiSelect
            v-model="noncompliance_model.standard_items"
            :options="noncompliance_model_standard_items"
            :filter="true"
            option-label="name"
            option-value="id"
            placeholder="Selecione ou pesquise"
            class="w-100"
          />
        </div>
        <div class="form-group">
          <label>Categoria</label>
          <Dropdown
            v-model="noncompliance_model.noncompliance_model_category_name"
            :editable="true"
            :options="noncompliance_model_categories"
            class="w-100"
            option-label="name"
            option-value="name"
          />
        </div>
        <div class="form-group" v-if="noncompliance_model.noncompliance_model_category_name == 'ESPAÇO CONFINADO'">
          <label>Centro de Custo</label>
          <Dropdown
            v-model="noncompliance_model.noncompliance_model_cost_center_name"
            :editable="true"
            :options="noncompliance_model_cost_centers"
            class="w-100"
            option-label="name"
            option-value="name"
          />
        </div>
        <div class="form-group" v-if="noncompliance_model.noncompliance_model_category_name == 'ESPAÇO CONFINADO'">
          <label>Probabilidade</label>
          <Dropdown
            v-model="noncompliance_model.probability"
            :editable="true"
            :options="noncompliance_model_probabilities"
            class="w-100"
            option-label="name"
            option-value="name"
            @change="onChangeDegreeOfRiskComponent"
          />
        </div>
        <div class="form-group" v-if="noncompliance_model.noncompliance_model_category_name == 'ESPAÇO CONFINADO'">
          <label>Consequência</label>
          <Dropdown
            v-model="noncompliance_model.consequences"
            :editable="true"
            :options="noncompliance_model_consequences"
            class="w-100"
            option-label="name"
            option-value="name"
            @change="onChangeDegreeOfRiskComponent"
          />
        </div>
        <div class="form-group" v-if="noncompliance_model.noncompliance_model_category_name == 'ESPAÇO CONFINADO'">
          <label>Grau de Risco</label>
          <Dropdown
            v-model="noncompliance_model.noncompliance_model_degree_of_risk_name"
            :disabled="true"
            :options="noncompliance_model_degrees_of_risk"
            class="w-100"
            option-label="name"
            option-value="name"
          />
        </div>
        <div class="form-group">
          <label>Tratativa</label>
          <textarea
            v-model="noncompliance_model.treatise"
            class="form-control"
            placeholder="Tratativa"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Tipo Adequação</label>
          <Dropdown
            v-model="noncompliance_model.noncompliance_model_adequacy_name"
            :editable="true"
            :options="noncompliance_model_adequacies"
            class="w-100"
            option-label="name"
            option-value="name"
          />
        </div>
        <div class="form-group">
          <label>Palavras Chave</label>
          <textarea
            v-model="noncompliance_model.keywords"
            class="form-control"
            placeholder="Palavras Chave"
          ></textarea>
        </div>
        <div class="form-group">
          <label
            >Descrição Reduzida (apenas para Escada de Marinheiro e Correia
            Transportadora)</label
          >
          <input
            type="text"
            v-model="noncompliance_model.short_description"
            class="form-control"
            placeholder="Descrição Reduzida"
          />
        </div>
        <div class="form-group">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="noncompliance_model.active"
              :value="1"
              id="active"
              aria-describedby="active_checkbox_help_text"
            />
            <label class="form-check-label" for="active">Ativo</label>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-6">
            <button class="btn btn-default" type="button" @click="openTable()">{{'<<'}} Voltar para a listagem</button>
          </div>
          <div class="col-6 d-flex flex-row-reverse">
            <button class="btn btn-dark">
              <font-awesome-icon :icon="['fas', 'save']"></font-awesome-icon>
              {{ submit_text }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { onMounted, ref } from 'vue'

  import { useRoute, useRouter } from 'vue-router'

  import useNoncomplianceModels from '@/modules/NoncomplianceModel.js'
  import useNoncomplianceModelAdequacies from '@/modules/NoncomplianceModelAdequacy.js'
  import useNoncomplianceModelCategories from '@/modules/NoncomplianceModelCategory.js'
  import useNoncomplianceModelNaturesOfRisk from '@/modules/NoncomplianceModelNatureOfRisk.js'
  import useNoncomplianceModelCostCenters from '@/modules/NoncomplianceModelCostCenter.js'
  import useNoncomplianceModelDegreesOfRisk from '@/modules/NoncomplianceModelDegreeOfRisk.js'
  import useNoncomplianceModelStandardItem from '@/modules/NoncomplianceModelStandardItem.js'
  import useDegreeOfRisk from '@/modules/DegreeOfRiskUtil.js'
  import MultiSelect from 'primevue/multiselect'

  import Dropdown from 'primevue/dropdown'

  export default {
    setup() {
      const route = useRoute()
      const router = useRouter()

      const loading = ref(true)
      const noncompliance_model_form = ref(null)

      const {
        listNoncomplianceModelAdequacies,
        noncompliance_model_adequacies,
      } = useNoncomplianceModelAdequacies()

      const {
        listNoncomplianceModelCategories,
        noncompliance_model_categories,
      } = useNoncomplianceModelCategories()

      const {
        listNoncomplianceModelNaturesOfRisk,
        noncompliance_model_natures_of_risk,
      } = useNoncomplianceModelNaturesOfRisk()

      const {
        listNoncomplianceModelCostCenters,
        noncompliance_model_cost_centers,
      } = useNoncomplianceModelCostCenters()

      const {
        listNoncomplianceModelDegreesOfRisk,
        noncompliance_model_degrees_of_risk,
      } = useNoncomplianceModelDegreesOfRisk()

      const {
        noncompliance_model_standard_items,
        listNoncomplianceModelStandardItems,
      } = useNoncomplianceModelStandardItem()

      const { saveNoncomplianceModel, getNoncomplianceModel } =
        useNoncomplianceModels()

      const {
        listProbabilities,
        listConsequences,
        noncompliance_model_probabilities,
        noncompliance_model_consequences,
        calculateDegreeOfRisk,
      } = useDegreeOfRisk()

      const noncompliance_model = ref({
        noncompliance_model_id: null,
        noncompliance_model_nature_of_risk_name: '',
        noncompliance_model_description: '',
        standard_items: [],
        noncompliance_model_category_name: '',
        treatise: '',
        noncompliance_model_adequacy_name: '',
        noncompliance_model_cost_center_name: '',
        noncompliance_model_degree_of_risk_name: '',
        keywords: '',
        short_description: '',
        active: false,
        probability: '',
        consequences: '',
      })

      const submit_text = ref('')

      const onSubmit = () => {
        const data = Object.assign({}, noncompliance_model.value)
        data.probability = noncompliance_model_probabilities.value.filter(p => p.name == data.probability)[0]?.value
        data.consequences = noncompliance_model_consequences.value.filter(p => p.name == data.consequences)[0]?.value
        
        saveNoncomplianceModel(data)
          .then(() => {
            router.push('/noncompliance-models')
          })
          .catch(() => {})
      }

      onMounted(async () => {
        await listNoncomplianceModelStandardItems()
        await listNoncomplianceModelNaturesOfRisk()
        await listNoncomplianceModelCategories()
        await listNoncomplianceModelAdequacies()
        await listNoncomplianceModelCostCenters()
        await listNoncomplianceModelDegreesOfRisk()
        listProbabilities()
        listConsequences()

        if (route.params.id) {
          await getNoncomplianceModel(route.params.id).then((response) => {
            noncompliance_model.value = response.data.data
            noncompliance_model.value.noncompliance_model_nature_of_risk_name =
              response.data.data.noncompliance_model_nature_of_risk.name
            noncompliance_model.value.noncompliance_model_category_name =
              response.data.data.noncompliance_model_category.name
            noncompliance_model.value.noncompliance_model_adequacy_name =
              response.data.data.noncompliance_model_adequacy.name
            noncompliance_model.value.noncompliance_model_cost_center_name =
              response.data.data.noncompliance_model_cost_center.name
            noncompliance_model.value.noncompliance_model_degree_of_risk_name =
              response.data.data.noncompliance_model_degree_of_risk.name
            noncompliance_model.value.standard_items =
              noncompliance_model.value.standard_items.map(
                (strandard_item) => strandard_item.id,
              )
          })

          submit_text.value = 'Salvar alterações'
        } else {
          submit_text.value = 'Cadastrar'
        }

        loading.value = false
      })

      return {
        noncompliance_model_standard_items,
        noncompliance_model_natures_of_risk,
        noncompliance_model_categories,
        noncompliance_model_adequacies,
        noncompliance_model_cost_centers,
        noncompliance_model_degrees_of_risk,
        noncompliance_model_form,
        noncompliance_model,
        noncompliance_model_probabilities,
        noncompliance_model_consequences,
        calculateDegreeOfRisk,
        submit_text,
        onSubmit,
        router
      }
    },
    components: {
      Dropdown,
      MultiSelect,
    },
    methods: {
      onChangeDegreeOfRiskComponent() {
        const app = this

        if (app.noncompliance_model?.probability && app.noncompliance_model?.consequences) {
          const probability_name = app.noncompliance_model.probability
          const consequences_name = app.noncompliance_model.consequences

          const probability = app.noncompliance_model_probabilities.filter(p => p.name == probability_name)[0].value
          const consequence = app.noncompliance_model_consequences.filter(c => c.name == consequences_name)[0].value

          const degreeOfRiskNumber = app.calculateDegreeOfRisk(probability, consequence) - 1
          const degreeOfRisk = app.noncompliance_model_degrees_of_risk[degreeOfRiskNumber].name
          app.noncompliance_model.noncompliance_model_degree_of_risk_name = degreeOfRisk
        }
      },
      openTable() {
        this.router.push('/noncompliance-models');
      }

    }
  }
</script>
